const whitespaceReg = /[/].*[/]/g;
const symbolReg = /["#]/g;

const cleanComment = (comment: string) =>
  comment.replace(whitespaceReg, '').replace(symbolReg, '');

export default cleanComment;
